<template>
    <div class="parent">
        <banner v-bind:bannerObj="bannerObj"></banner>
        <div class="container">
            <div class="content">
                <div class="curmbsLink">
                    <router-link to="/products">产品与服务</router-link>
                    <span> > </span>
                    <span>支付结算服务</span>
                </div>
                <div class="address">
                    <div>
                        <b>GET</b>
                        <span>一站式跨境金融服务</span>
                        <p>专注为跨境企业和个人客户提供国际收付、货币兑换、供应 链融资、汇率风险管理方案等一站式跨境金融服务。 </p>
                    </div>
                </div>
                <div class="textWrap">
                    <span>基本介绍</span>
                    <p>1. 国际收付：与国内外多家支付公司合作，为您提供高效率、低费率的跨境资金收付服务。</p>
                    <p>2. 货币兑换：为您提供多币种的实时汇率查询，即期或远期货币兑换服务。</p>
                    <p>3. 供应链融资：拥有强大的合作资源，为您提供定制化的供应链金融方案，解决资金周转问题，助力扩大经营规模。</p>
                    <p>4. 汇率风险管理：与银行相比，我们提供的汇率风险管理门槛低、申请流程简便，并且还可以根据您的需求提供个性化的外汇服务，满足您的交易场景和碎片化需求。 </p>
                </div>
            </div>
        </div>
        <footer>
            <footContent></footContent>
        </footer>
    </div>
</template>

<style lang="scss">
    .parent{
        background-color: #fff;
        .container {
            width: 1200px;
            margin: 0 auto;
            padding-top: 64px;
        }
        .content { margin-bottom: 80px; }
        .curmbsLink {
            width: 100%;
            line-height: 30px;
            margin-bottom: 20px;
            a { color: rgba(50,50,50, 0.3);  cursor: pointer}
            a:hover { color: #323232; }
        }
        .address {
            width: 100%;
            height: 450px;
            margin-bottom: 60px;
            background: url('../assets/images/photograph.png') no-repeat;
            background-size: auto 100%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-end;
            align-items: center;
            position: relative;
            > div:after {
                content: '';
                position: absolute;
                bottom: -2px;
                right: 50px;
                z-index: 1;
                width: 162px;
                height: 70px;
                background: #FEBD00;
                box-shadow: 0 0 50px rgba(0,0,0,0.2);
                border-top-left-radius: 45px;
                border-bottom-right-radius: 45px;
            }
            > div {
                width: 717px;
                height: 364px;
                background: #fff;
                border-top-left-radius: 45px;
                border-bottom-right-radius: 45px;
                box-shadow: 0 0 40px rgba(0,0,0,0.15);
                display: flex;
                flex-flow: column nowrap;
                justify-content: center;
                align-items: center;
                b, span, p { width: 80%; }
                b {
                    display: block;
                    font-size: 48px;
                    font-weight: 800;
                    margin-bottom: 20px;
                }
                span {
                    display: block;
                    font-size: 30px;
                    font-weight: bold;
                    text-indent: 40px;
                    position: relative;
                    margin-bottom: 40px;
                }
                span:after {
                    content: '';
                    width: 12px;
                    height: 12px;
                    background: #FEBD00;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    margin: auto;
                    z-index: 1;
                }
                p { font-size: 20px; color: #323232; line-height: 30px;}
            }
        }
        .textWrap {
            span {
                display: block;
                font-size: 30px;
                text-indent: 40px;
                margin-bottom: 40px;
                position: relative;
            }
            span:after {
                content: '';
                width: 18px;
                height: 18px;
                background: #FEBD00;
                position: absolute;
                left: 0;
                top: 10px;
                z-index: 2;
            }
            span:before {
                content: '';
                width: 18px;
                height: 18px;
                background: #cbcbcb;
                position: absolute;
                left: 6px;
                top: 4px;
                z-index: 1;
            }
            p { line-height: 30px; }
        }
    }

</style>


<script>
import store from '../vuex'
import DetailBanner from '../components/DetailBanner'
import FootContent from "../components/FootContent.vue";
// import Child from '../components/Child.vue'
export default {
  data() {
      return {
        bannerObj: {
            imgUrl: require('../assets/images/products.png'),
            text: 'PRODUCTS & SOLUTIONS',
        }
      }
  },
  components:{
    'banner': DetailBanner,
    'footContent': FootContent,
  },
  store,
}
</script>

